<div class="barcode-table-container space-y-4">
  <div class="flex items-center justify-between gap-2 mb-1.5">
    @if (showTitle) {
      <h4 class="font-semibold text-gray-800 text-sm">
        {{ title | translate }}
      </h4>
    }
    @if (!viewMode) {
      <div class="flex gap-2 ml-auto">
        <app-button
          [label]="'sku_management.barcode.actions.add_row' | translate"
          type="info"
          size="small"
          [outlined]="true"
          (emitOnClick)="onAddBarcode()"
        ></app-button>
        <app-button
          [label]="'sku_management.barcode.actions.delete_selected' | translate"
          type="danger"
          size="small"
          [outlined]="true"
          [disabled]="selectedBarcodes.length === 0"
          (emitOnClick)="onDeleteSelectedBarcodes()"
        ></app-button>
      </div>
    }
  </div>

  <app-data-table
    [dataSource]="displayBarcodes()"
    [columns]="barcodeTableColumns()"
    [rows]="displayBarcodes().length"
    [first]="0"
    [totalRecords]="displayBarcodes().length"
    [loading]="false"
    [selection]="viewMode ? [] : selectedBarcodes"
    [hasCheckColumn]="!viewMode"
    [hasSerialColumn]="false"
    [showPaginator]="false"
    (selectionChange)="onSelectionChange($event)"
  >
    <!-- Actions Template -->
    @if (!viewMode) {
      <ng-template #actionsTemplate let-rowData>
        <div class="flex gap-2 justify-center">
          <span
            (click)="onEditBarcode(rowData)"
            class="action-link action-edit cursor-pointer"
          >
            {{ "common.actions.edit" | translate }}
          </span>
          <span
            (click)="onDeleteBarcode(rowData)"
            class="action-link action-delete cursor-pointer"
          >
            {{ "common.actions.delete" | translate }}
          </span>
        </div>
      </ng-template>
    }
  </app-data-table>
</div>
